import { mergeAbortSignals } from '@app/utils/mergeAbortSignals'

import { withChildContext } from '@app/packages/actionContext/actions'

import type { ThunkAction } from '@app/store/thunk'
import { createThunk } from '@app/store/thunk'

import { AbortSignalsManager } from './AbortSignalsManager'

export function withAbortSignal<R>(abortSignal: AbortSignal | undefined, action: ThunkAction<R>) {
  if (!abortSignal) return action
  return withChildContext(
    createThunk(async dispatch => {
      using stack = new DisposableStack()
      const manager = dispatch(getAbortSignalsManager())
      stack.use(manager.add(abortSignal))
      return await dispatch(action)
    }) as typeof action
  )
}

export function getAbortSignalsManager() {
  return createThunk((_dispatch, _getState, context) => {
    return context.getOrInsert<AbortSignalsManager>(AbortSignalsManagerSymbol, () => new AbortSignalsManager())
  })
}

const AbortSignalsManagerSymbol = Symbol('AbortSignalsManager')

export function getAbortSignal() {
  return createThunk((_dispatch, _getState, context) => {
    const managers = context.tree<AbortSignalsManager>(AbortSignalsManagerSymbol)
    const signals = managers.flatMap(m => m.signals.map(s => s.value))
    if (!signals.length) return undefined
    return mergeAbortSignals(...signals)
  })
}
